import { render } from "./EditOrganePage.vue?vue&type=template&id=714c291c&ts=true"
import script from "./EditOrganePage.vue?vue&type=script&lang=ts"
export * from "./EditOrganePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__